export * from './IconPrinterFilled';
